import React from 'react';
import Typography from '../Typography';

const ForbiddenPage = () => {
  return (
    <div className="mt-16 flex-1 text-center">
      <div className="mx-auto flex w-4/5 items-center justify-center rounded-[20px] bg-[#EEE] p-5 dark:bg-[#666]">
        <div>
          <Typography variant="h1" className="mb-8" color="error">
            403
          </Typography>
          <Typography variant="h5" color="textSecondary">
            Oops! Acesso Negado!
          </Typography>
          <a
            href="/tickets"
            className="mt-4 inline-flex h-10 items-center justify-center rounded-full bg-[var(--primaryColor)] px-5 text-sm font-semibold text-white shadow-none hover:brightness-90"
          >
            Voltar
          </a>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;
